import {
  TEL_RULE,
  CHECK_DISTRIBUTOR_NAME,
  CHECK_PIN,
  CHECK_BUSINESS_LICENSE,
  CHECK_BUSINESSLICENSEPIC,
  CHECK_TEL,
  CHECK_ERP,
} from './validate-rule'
import validator from '@/base/validate-base.js'
export const OWNER_COMPANY_INFO_RULE = function () {
  return {
    workAddress: [
      { required: true, message: '请输入办公地址' },
      { max: 500, message: '办公地址请限制在500个字符内', trigger: 'blur' },
    ],
    contracter: [
      { required: true, message: '请输入联系人姓名' },
      { max: 50, message: '联系人姓名请限制在50个字符内', trigger: 'blur' },
    ],
    tel: [
      { required: true, message: '请输入联系电话' },
      { validator: CHECK_TEL.bind(this), trigger: 'blur' },
    ],
    email: [
      { required: true, message: '请输入邮箱地址' },
      { max: 100, message: '邮箱地址请限制在100个字符内' },
      {
        type: 'email',
        message: '请输入正确的邮箱地址',
        trigger: 'blur',
      },
    ],
  }
}

export const EDIT_INVOICE_INFORMATION_RULE = function () {
  return {
    invoiceTitle: [{ required: true, message: '请输入公司名称' }],
    taxNumber: [{ required: true, message: '纳税人识别号' }],
  }
}

// 客户信息修改
export const CLIENT_COMPANY_INFO_RULE = {
  tel: [
    { required: true, message: '请输入联系电话' },
    { validator: TEL_RULE, trigger: 'blur' },
  ],
  email: [
    { required: true, message: '请输入邮箱地址' },
    { max: 100, message: '邮箱地址请限制在100个字符内' },
    {
      type: 'email',
      message: '请输入正确的邮箱地址',
      trigger: 'blur',
    },
  ],
  remark: [{ max: 200, message: '最多输入200个字', trigger: 'blur' }],
}
/*
  二级渠道商的验证规则
*/
export const SERVICE_PROVIDER_CREATE_RULE = function () {
  return {
    distributorName: [
      { required: true, message: '请输入渠道商名称' },
      { max: 100, message: '渠道商名称请限制在100个字符内', trigger: 'blur' },
      {
        validator: CHECK_DISTRIBUTOR_NAME.bind(this),
        trigger: 'blur',
      },
    ],
    pin: [
      { required: true, message: '请输入京东云账户' },
      { max: 30, message: '京东云账户请限制在30个字符内', trigger: 'blur' },
      {
        validator: CHECK_PIN.bind(this),
        trigger: 'blur',
      },
    ],
    businessLicense: [
      { required: true, message: '请输入营业执照号' },
      { max: 20, message: '营业执照号请限制在20个字符内', trigger: 'blur' },
      {
        validator: CHECK_BUSINESS_LICENSE.bind(this),
        trigger: 'blur',
      },
    ],
    businessLicensePic: [
      {
        validator: CHECK_BUSINESSLICENSEPIC,
      },
    ],
    legalRepresentative: [
      { required: true, message: '请输入法定代表人' },
      { max: 100, message: '法定代表人请限制在100个字符内', trigger: 'blur' },
    ],
    businessDesc: [
      { required: true, message: '请输入主营业务描述' },
      { max: 500, message: '主营业务描述请限制在500个字符内', trigger: 'blur' },
    ],
    workAddress: [
      { required: true, message: '请输入办公地址' },
      { max: 500, message: '办公地址请限制在500个字符内', trigger: 'blur' },
    ],
    contracter: [
      { required: true, message: '请输入联系人姓名' },
      { max: 100, message: '联系人姓名请限制在100个字符内', trigger: 'blur' },
    ],
    tel: [
      { required: true, message: '请输入联系电话' },
      { max: 50, message: '联系电话请限制在50个字符内', trigger: 'blur' },
      {
        validator: TEL_RULE,
        trigger: 'blur',
      },
    ],
    email: [
      { required: true, message: '请输入邮箱地址' },
      { max: 100, message: '邮箱地址请限制在100个字符内', trigger: 'blur' },
      {
        type: 'email',
        message: '请输入正确格式的邮箱地址',
        trigger: 'blur',
      },
    ],
    bankCompanyName: [
      { required: true, message: '请输入银行开户名', trigger: 'blur' },
      { max: 100, message: '银行开户名限制在100个字符内', trigger: 'blur' },
    ],
    bankCardNo: [
      { required: true, message: '请输入银行账号', trigger: 'blur' },
      { pattern: validator.reg.validateNumber, message: '只支持输入数字' },
      { max: 50, message: '银行账号限制在50个字符内', trigger: 'blur' },
    ],
    bankBranchName: [
      { required: true, message: '请输入开户行支行名称', trigger: 'blur' },
      { max: 100, message: '开户行支行名称限制在100个字符内', trigger: 'blur' },
    ],
    bankBranchNo: [
      { required: true, message: '请输入开户行支行银联号', trigger: 'blur' },
      { max: 50, message: '开户行支行银联号限制在50个字符内', trigger: 'blur' },
    ],
    erp: [
      { required: true, message: '请输入所属京东云销售', trigger: 'blur' },
      {
        validator: CHECK_ERP,
        trigger: 'blur',
      },
    ],
  }
}

export const DISTRIBUTOR_COMPANY_INFO_RULE = {
  businessDesc: [
    { required: true, message: '请输入主营业务描述', trigger: 'blur' },
    { max: 500, message: '主营业务描述请限制在500个字符内', trigger: 'blur' },
  ],
}
